"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInfiniteLoader = void 0;
const react_1 = require("react");
function useInfiniteLoader({ loadMore, canLoadMore = false, initialise = true, rootMargin = '100px 0px 0px 0px', threshold = 0, debug = false, }) {
    const loaderRef = (0, react_1.useRef)(null);
    const observer = (0, react_1.useRef)(null);
    const log = (0, react_1.useCallback)((...args) => debug && console.log(...args), [debug]);
    if (typeof loadMore !== 'function') {
        throw new TypeError('useInfiniteLoader: loadMore must be a function and is required');
    }
    (0, react_1.useEffect)(() => {
        if (!observer.current && initialise) {
            log('Initialised');
            observer.current = new IntersectionObserver(([target]) => {
                log('Observer invoked');
                if (target.intersectionRatio <= 0) {
                    log('Intersection ratio not met');
                    return;
                }
                if (!canLoadMore) {
                    log('Can load more is false');
                    return;
                }
                log('Loading more...');
                loadMore();
            }, { rootMargin, threshold });
            if (loaderRef.current) {
                log('Observing loader ref');
                observer.current.observe(loaderRef.current);
            }
        }
        return () => {
            if (observer === null || observer === void 0 ? void 0 : observer.current) {
                observer.current.disconnect();
                observer.current = null;
            }
        };
    }, [canLoadMore, loadMore, initialise, log, rootMargin, threshold]);
    return { loaderRef };
}
exports.useInfiniteLoader = useInfiniteLoader;
